// Wishlist.js
import React, { useEffect, useState } from "react";
import "./Wishlist.css";
import Common_Back_Header from "../common/common_components/common_back_header/Common_Back_Header";
import Product_card_2 from "../common/common_components/product-card-2/Product_card_2";
import { IDS } from "../../utils/IDS";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";
import { useDispatch, useSelector } from "react-redux";
import { encodeId } from "../../utils/common";

const Wishlist = () => {

  const dispatch = useDispatch();
  const allWishlist = useSelector((state) => state.wishlist.allWishlist);


  useEffect(() => {
    dispatch(getAllWishlist());
  }, [dispatch]);

  const removeFromWishlist = (id) => {
    // setWishlistItems((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <section className="Wishlist">
      <div className="container">
        <Common_Back_Header backNavigation={-1} />

        {allWishlist?.data?.length === 0 ? (
          <div className="no-products text-center py-5">
            <h4>No products available in your wishlist.</h4>
          </div>
        ) : (
          <div className="row">
            {allWishlist?.data?.map((data) => (
              <div
                key={data.id}
                className="col-xxl-3 col-xl-4 col-lg-4 col-6 mb-4 p-sm-auto p-1"
              >
                <Product_card_2
                  average_rating={data?.Product?.average_rating}
                  id={data?.Product?.id}
                  image={IDS.IMG_URL + data?.Product?.image}
                  name={data.Product?.name}
                  subname={`(${data?.Product?.p_category?.name})`}
                  oldprise={data.Product?.mrp}
                  prise={data.Product?.price}
                  link={`/product-details/${encodeId(data.Product?.id)}`} // remove handler
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Wishlist;
